import BoardTool from '@/components/common/ed-board/ed-board-tools/board-tool.interface';
import WboDrawerTools from '@/components/common/ed-board/ed-board-tools/ed-wbo-drawer/wbo-drawer-tools';
import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { Store } from 'vuex';

/********************************** WHITEBOPHIR ***************************************************
 * This class was taken and adapted for the EDUAC project from the WHITEBOPHIR project            *
 * https://github.com/lovasoa/whitebophir, keeping the same distribution and license conditions.  *
 **************************************************************************************************
 */
export default class EdWboDrawerEraser {

    private erasing: boolean = false;
    private wboDrawerTools: WboDrawerTools;
    private setCursorBoardMutation: any;
    private msg = {
        type : 'delete',
        id   : '',
        audit: false
    };

    private startErasing: Function = (x: number, y: number, evt: any) => {
        //Prevent the press from being interpreted by the browser
        evt.preventDefault();
        if(this.setCursorBoardMutation) {
            this.setCursorBoardMutation(false);
        }
        this.erasing = true;
        this.erase(x, y, evt);
    }

    private inDrawingArea: Function = (elem: any) => {
        return this.wboDrawerTools.drawingArea.contains(elem);
    }

    private erase: Function = (x: number, y: number, evt: any) => {
        // evt.target should be the element over which the mouse is...
        let target = evt.target;
        if (evt.type === 'touchmove') {
            // ... the target of touchmove events is the element that was initially touched,
            // not the one **currently** being touched
            let touch = evt.touches[0];
            target = document.elementFromPoint(touch.clientX, touch.clientY);
        }
        if (this.erasing && target !== this.wboDrawerTools.svg && target !== this.wboDrawerTools.drawingArea && this.inDrawingArea(target)) {
            if (!this.wboDrawerTools.annotations.includes(target.id) && !this.wboDrawerTools.isHostUser) {
                return;
            }
            this.msg.id = target.id;
            this.wboDrawerTools.drawAndSend(this.msg);
        }

    }

    private stopErasing: Function = () => {
        this.erasing = false;
        if(this.setCursorBoardMutation) {
            this.setCursorBoardMutation(true);
        }
    }

    private draw: Function = (data: any, isMadeByUser: boolean = true) => {
        let elem: any;
        switch (data.type) {
            //TODO: add the ability to erase only some points in a line
            case 'delete': {
                if (isMadeByUser && !this.wboDrawerTools.isHostUser && this.wboDrawerTools.annotationOwners[data.id]?.userName !== this.wboDrawerTools.username) {
                    // If the deletion is made by the user,  he can't erase elements that are not owned by him, unless he's a host
                    return false;
                }
                elem = this.wboDrawerTools.svg.getElementById(data.id);
                if (elem !== null) {
                    this.wboDrawerTools.drawingArea.removeChild(elem);
                }
                break;
            }
            default:
                break;
        }
        return true;
    }

    private eraserTool: BoardTool = { //The new tool
        name       : 'Eraser',
        shortcut   : 'e',
        listeners  : {
            press  : this.startErasing,
            move   : this.erase,
            release: this.stopErasing
        },
        draw       : this.draw,
        icon       : '/assets/tools/eraser/icon.svg',
        mouseCursor: 'crosshair',
        showMarker : true
    }

    constructor(tools: WboDrawerTools, setMutationTrue: any = null) {
        this.wboDrawerTools = tools;
        this.setCursorBoardMutation = setMutationTrue;
        this.wboDrawerTools.add(this.eraserTool);
    }

}